import CoinsSwapIcon from 'app/components/Icons/CoinsSwapIcon';
import BankIcon from 'app/components/Icons/BankIcon';
import ManatIcon from 'app/components/Icons/ManatIcon';
import GlobusIcon from 'app/components/Icons/GlobusIcon';
import SwitchIcon from 'app/components/Icons/SwitchIcon';
import CoinsStackedIconSelect from 'app/components/Icons/CoinsStackedIconSelect';
import WalletIconSelect from 'app/components/Icons/WalletIconSelect';

import i18n from 'i18next';

let templatesOptions: Array<{
  value: string;
  label: string;
  icon: JSX.Element;
  templateType: string;
}> = [];

i18n.on('loaded', () => {
  templatesOptions = [
    {
      value: i18n.t('commonTerms.paymentProcessType.acc2acc'),
      label: i18n.t('commonTerms.paymentProcessType.acc2acc'),
      icon: <CoinsSwapIcon />,
      templateType: 'payment_acc2acc',
    },
    {
      value: i18n.t('commonTerms.paymentProcessType.inBank'),
      label: i18n.t('commonTerms.paymentProcessType.inBank'),
      icon: <BankIcon />,
      templateType: 'payment_interbank',
    },
    {
      value: i18n.t('commonTerms.paymentProcessType.inCountry'),
      label: i18n.t('commonTerms.paymentProcessType.inCountry'),
      icon: <ManatIcon />,
      templateType: 'payment_local_transfer',
    },
    {
      icon: <GlobusIcon />,
      templateType: 'payment_foreign_transfer',
      value: i18n.t('commonTerms.paymentProcessType.internal'),
      label: i18n.t('commonTerms.paymentProcessType.internal'),
    },
    {
      icon: <SwitchIcon sx={{ width: '20px', height: '20px' }} />,
      templateType: 'payment_conversion',
      value: i18n.t('commonTerms.paymentProcessType.conversion'),
      label: i18n.t('commonTerms.paymentProcessType.conversion'),
    },
    {
      icon: <CoinsStackedIconSelect />,
      templateType: 'payment_edv',
      value: i18n.t('commonTerms.paymentProcessType.edv'),
      label: i18n.t('commonTerms.paymentProcessType.edv'),
    },
    {
      icon: <WalletIconSelect />,
      templateType: 'payment_budget',
      value: i18n.t('commonTerms.paymentProcessType.stateBudget'),
      label: i18n.t('commonTerms.paymentProcessType.stateBudget'),
    },
  ];
});
export { templatesOptions };
